import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {EnumModel} from '../../../shared/objects/EnumModel';
import {MemberDatabaseListModel} from '../member-management.model';
import {ExpireDatesMemberRequestModel, ExpiryDatesMemberModel} from './expiry-dates.model';
import {DateHelper} from '../../../shared/helpers/date-helper';
import {MemberManagementService} from '../member-management.service';
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-expiry-dates',
  templateUrl: './expiry-dates.component.html',
  styleUrls: ['./expiry-dates.component.less']
})
export class ExpiryDatesComponent implements OnInit {
  @Input() inputMembers: MemberDatabaseListModel[];
  @Output() onClose = new EventEmitter<boolean>();

  members = new Array<ExpiryDatesMemberModel>();
  expiryDateOptions = [
    new EnumModel(3, '3 months'),
    new EnumModel(6, '6 months'),
    new EnumModel(12, '12 months'),
    new EnumModel('unlimited', 'Unlimited'),
    new EnumModel('specific', 'Specific date')
  ];
  selectedExpiryDate = this.expiryDateOptions[0];


  date = new Date();
  minDate = new Date();

  enabled = true;

  payingMembersSelected: boolean;

  constructor(private service: MemberManagementService) {
  }

  ngOnInit() {
    for (const member of this.inputMembers) {
      const newMember = new ExpiryDatesMemberModel();
      newMember.id = member.id;
      newMember.name = member.fullName;
      newMember.isPremium = member.membershipType.toLowerCase() === 'premium';
      newMember.expiryDate = newMember.isPremium ?
        (member.expiryDate ?
          new DatePipe('en-GB').transform(new Date(member.expiryDate), 'dd/MM/yyyy') :
          'Unlimited') :
        '-';
      newMember.isPayingMember = member.isPayingMember;
      newMember.memberObj = member;
      this.members.push(newMember);

      if(member.isPayingMember){
        this.payingMembersSelected = true;
      }
    }
    this.recalculateExpireDates(null);
  }

  recalculateExpireDates(e) {
    if (this.selectedExpiryDate.id === 3 || this.selectedExpiryDate.id === 6 || this.selectedExpiryDate.id === 12) {
      for (const member of this.members) {
        if (member.isPremium && member.memberObj.expiryDate) {
          // member.newExpiryDate = DateHelper.addMonths(member.memberObj.expiryDate, this.selectedExpiryDate.id).toLocaleDateString() ;

          member.newExpiryDate = new DatePipe('en-GB').transform(DateHelper.addMonths(member.memberObj.expiryDate, this.selectedExpiryDate.id), 'dd/MM/yyyy');


        } else {
          member.newExpiryDate = new DatePipe('en-GB').transform(DateHelper.addMonths(new Date(), this.selectedExpiryDate.id), 'dd/MM/yyyy');
          // member.newExpiryDate = DateHelper.addMonths(new Date(), this.selectedExpiryDate.id).toLocaleDateString() ;
        }
      }
    }
    if (this.selectedExpiryDate.id === 'unlimited') {
      for (const member of this.members) {
        member.newExpiryDate = 'Unlimited';
      }
      return;
    }
    if (this.selectedExpiryDate.id === 'specific') {
      for (const member of this.members) {
        member.newExpiryDate = new DatePipe('en-GB').transform(this.date, 'dd/MM/yyyy');

        // this.date.toLocaleDateString();
      }
    }
  }

  save() {

    const request = new Array<ExpireDatesMemberRequestModel>();
    for (const member of this.members) {
      const item = new ExpireDatesMemberRequestModel();

      const [day, month, year] = member.newExpiryDate.split('/');

      item.date = this.selectedExpiryDate.id !== 'unlimited' ? new Date(parseInt(year), parseInt(month) - 1, parseInt(day)) : null;
      item.id = member.id;
      request.push(item);
    }
    this.enabled = false;
    const component = this;
    this.service.updateExpireDates(request).subscribe(
      (r) => this.close(true),
      (e) => component.enabled = true);
  }

  close(refresh = false) {
    this.onClose.emit(refresh);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/member-management/member-actions/expiry-dates.component.ts